import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            // Small delay to not show immediately on page load
            const timer = setTimeout(() => setShowBanner(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        localStorage.setItem('cookie-consent-date', new Date().toISOString());
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie-consent', 'declined');
        localStorage.setItem('cookie-consent-date', new Date().toISOString());
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-content">
                <h4>🍪 Usamos cookies</h4>
                <p>
                    Este sitio utiliza cookies para mejorar tu experiencia y analizar el tráfico.
                    Al continuar navegando, aceptas nuestra{' '}
                    <Link to="/privacy-policy">Política de Privacidad</Link>.
                </p>
            </div>
            <div className="cookie-actions">
                <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
                    Rechazar
                </button>
                <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
                    Aceptar
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
